<template>
  <b-modal
    :visible="visible"
    centered
    modal-class="status-update-modal iu-modal sts_update_modal_sp"
    no-close-on-backdrop
    size="sm"
    title="Edit Intended User"
    @change="val => $emit('update:visible', val)"
  >
    <b-form-group
      label="Name*"
      label-for="h-iu-name"
    >
      <b-input-group>
        <b-form-input
          id="h-iu-name"
          v-model="nameValue"
          :disabled="identityLocked"
          class="text-uppercase"
          placeholder="Name"
        />
        <b-input-group-append
          v-if="singpass"
          is-text
          class="singpass-block_spt"
        >
          <b-badge
            variant="secondary"
            class="singpass-badge"
          >
            via Singpass
          </b-badge>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group
      label="NRIC*"
      label-for="h-iu-nric"
    >
      <b-form-input
        id="h-iu-nric"
        v-model="nricValue"
        :disabled="identityLocked"
        class="text-uppercase"
        placeholder="NRIC"
      />
    </b-form-group>

    <b-form-group
      label="Date of Birth*"
      label-for="h-iu-dob"
      class="calendar_sp_icon"
    >
      <flat-pickr
        id="h-iu-dob"
        v-model="dobValue"
        class="form-control"
        placeholder="Date of Birth"
        :disabled="identityLocked"
        :config="flatPickrConfig"
      />
      <feather-icon
        icon="CalendarIcon"
        class="calendar-icon"
        size="16"
      />
    </b-form-group>

    <b-form-group
      label="Relationship*"
      label-for="h-iu-relation"
    >
      <v-select
        id="h-iu-relation"
        v-model="relationValue"
        :options="relationshipOptions"
        :clearable="false"
        class="text-uppercase"
      />
    </b-form-group>

    <template #modal-footer="{}">
      <b-button
        variant="flat-primary"
        :disabled="saving"
        @click="$emit('update:visible', false)"
      >
        Cancel
      </b-button>
      <b-button
        variant="success-custom"
        type="button"
        :disabled="saving"
        @click="save"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Save Changes</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BBadge,
    vSelect,
    flatPickr,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    // Per-nominee Singpass flag - distinct from the submission/order-level Purchaser Details
    // singpass. Locks Name/NRIC/DOB the same way; Relationship always stays editable.
    singpass: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    nric: {
      type: String,
      default: '',
    },
    dob: {
      type: String,
      default: null,
    },
    relation: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nameValue: this.name,
      nricValue: this.nric,
      dobValue: this.dob,
      relationValue: this.relation,
      flatPickrConfig: {
        dateFormat: 'd/m/Y',
        disableMobile: true,
      },
      relationshipOptions: [
        'Brother', 'Brother in-law', 'Cousin', 'Daughter', 'Daughter in-law', 'Elder Brother', 'Father', 'Father in-law',
        'Friend', 'God-father', 'Grand Daughter', 'Grandfather', 'Grandmother', 'Grandson', 'Great Grand Father',
        'Great Grand Mother', 'Husband', 'Mother', 'Mother in-law', 'N/A', 'Nephew', 'Niece', 'Relative', 'Self', 'Sister',
        'Sister in-law', 'Son', 'Son in-law', 'Uncle', 'Wife',
      ],
    }
  },
  computed: {
    identityLocked() {
      return this.singpass
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.nameValue = this.name
        this.nricValue = this.nric
        this.dobValue = this.dob
        this.relationValue = this.relation
      }
    },
  },
  methods: {
    save() {
      this.$emit('save', {
        name: this.nameValue,
        nric: this.nricValue,
        dob: this.dobValue,
        relation: this.relationValue,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.singpass-badge {
  background-color: transparent !important;
  color: #6e6b7b !important;
  border: 1px solid #d8d6de;
}
</style>
